import React from 'react'
import './GameStats.css'

export default function GameStats({ score, lines, level }) {
  return (
    <div className="sidebar left-sidebar">
      <div className="info-panel">
        <h3>PONTUAÇÃO</h3>
        <div className="stat-value">{score}</div>
      </div>
      <div className="info-panel">
        <h3>LINHAS</h3>
        <div className="stat-value">{lines}</div>
      </div>
      <div className="info-panel">
        <h3>NÍVEL</h3>
        <div className="stat-value">{level}</div>
      </div>
    </div>
  )
}
